import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

export const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/94774468660"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 md:bottom-10 md:right-10 z-[9999] bg-[#25D366] text-white p-3 md:p-3.5 rounded-full shadow-2xl hover:scale-110 hover:shadow-[0_10px_25px_rgba(37,211,102,0.5)] transition-all duration-300 flex items-center justify-center group"
      aria-label="Chat with us on WhatsApp"
    >
      <FaWhatsapp className="w-6 h-6 md:w-7 md:h-7 group-hover:rotate-12 transition-transform duration-300" />
    </a>
  );
};